type GroupedAction =
    | 'archiveStickers'
    | 'download'
    | 'dynamicRenamingExport'
    | 'duplicate'
    | 'export'
    | 'generateStickers'
    | 'group'
    | 'mailingList'
    | 'preOrder'
    | 'printStickers'
    | 'publish'
    | 'remove'
    | 'rename'
    | 'reporting'
    | 'share'
    | 'shopping'
    | 'tag'
    | 'transform'
    | 'unPublish'

export default GroupedAction

export const GroupedActionIcon = {
    archiveStickers: 'box-archive',
    download: 'cloud-arrow-down',
    dynamicRenamingExport: 'cloud-arrow-down',
    duplicate: 'clone',
    export: 'file-spreadsheet',
    generateStickers: 'plus',
    group: 'layer-group',
    mailingList: 'envelopes-bulk',
    preOrder: 'shopping-cart',
    printStickers: 'print',
    publish: 'signal-bars',
    remove: 'trash-can',
    rename: 'i-cursor',
    reporting: 'flag',
    restore: 'trash-can-undo',
    share: 'share-nodes',
    shopping: 'shopping-cart',
    tag: 'tags',
    transform: 'wand-magic-sparkles',
    unPublish: 'signal-slash',
}
